/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Můj kód slevy nefunguje`
};

const da_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Min rabatkode virker ikke`
};

const de_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Mein Rabattcode funktioniert nicht`
};

const en_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `My promo code does not work`
};

const es_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Mi código promocional no funciona`
};

const fr_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Mon code promo ne fonctionne pas`
};

const hu_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `A promóciós kódom nem működik`
};

const it_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Il mio codice sconto non funziona`
};

const nl_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Mijn kortingscode werkt niet`
};

const pl_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Mój kod rabatowy nie działa`
};

const pt_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Meu código promocional não funciona`
};

const sv_contact_other_subjects_promo_code_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Min rabattkod fungerar inte`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_other_subjects_promo_code_issue = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_other_subjects_promo_code_issue(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_other_subjects_promo_code_issue", locale)
	if (locale === "cs") return cs_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "da") return da_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "de") return de_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "en") return en_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "es") return es_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "fr") return fr_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "hu") return hu_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "it") return it_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "nl") return nl_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "pl") return pl_contact_other_subjects_promo_code_issue(inputs)
	if (locale === "pt") return pt_contact_other_subjects_promo_code_issue(inputs)
	return sv_contact_other_subjects_promo_code_issue(inputs)
};
export { contact_other_subjects_promo_code_issue as "contact.other_subjects.promo_code_issue" }